<template>
  <div>
    <b-card-group deck>
      <b-card footer-tag="footer" header-tag="header">
        <template #header>
          <h6 v-if="customtitleright && customtitleright !== undefined" class="mb-0 float-left">
            {{ customtitleright }}
          </h6>
          <br v-if="customtitleright && customtitleright !== undefined" />
          <h6 v-if="customtitleleft && customtitleleft !== undefined" class="mb-0 float-left">
            {{ customtitleleft }}
          </h6>
          <b-button
            v-if="showbackbutton"
            :to="urlbackbutton"
            class="float-left"
            size="sm"
            variant="info"
            ><i class="fa fa-arrow-left"></i> Kembali
          </b-button>
          <h6
            v-if="customtitleleft === undefined && customtitleright === undefined"
            class="mt-1 ml-2 mb-0 float-left"
          >
            {{ title }}
          </h6>
          <b-modal v-model="modalQR.show" :title="modalQR.title" size="xl">
            <div id="printerDiv" class="text-center">
              <iframe :class="modalQR.class" :src="modalQR.url"></iframe>
            </div>
            <template #modal-footer="{}">
              <b-button size="sm" variant="primary" @click="printDivQR()">
                <i class="fas fa-print mr-1"></i>
                Print
              </b-button>
              <template v-if="modalQR.paginate">
                <b-row>
                  <b-col class="mt-3 mr-2" cols="2">
                    <b-form inline>
                      <b-form-select
                        id="per-page-select"
                        v-model="modalQR.limit"
                        :options="[5, 8, 10, 25, 50, 100]"
                        class="mb-2 mr-sm-2 mb-sm-0"
                        size="sm w-35"
                        @change="fetchQRCode"
                      ></b-form-select>
                    </b-form>
                  </b-col>
                  <b-col class="mt-3" cols="9">
                    <b-pagination
                      v-model="modalQR.page"
                      :per-page="modalQR.limit"
                      :total-rows="modalQR.count"
                      class="mr-sm-2"
                      first-text="First"
                      last-text="Last"
                      next-text="Next"
                      prev-text="Prev"
                      size="sm"
                      @input="fetchQRCode"
                    ></b-pagination>
                  </b-col>
                </b-row>
              </template>
            </template>
          </b-modal>
          <b-modal v-model="modalQRLembaga.show" :title="modalQRLembaga.title" size="lg">
            <div id="printerDivLembaga" class="text-center">
              <VueQRCodeComponent :size="480" :text="modalQRLembaga.text"></VueQRCodeComponent>
            </div>
            <template #modal-footer="{}">
              <b-button size="sm" variant="primary" @click="printDivQRLembaga()">
                <i class="fas fa-print mr-1"></i>
                Print QR
              </b-button>
            </template>
          </b-modal>
          <b-modal v-model="modalLimitRek.show" :title="modalLimitRek.title" size="md">
            <form ref="form">
              <b-form-group label="Max Transaction" label-for="max-transaction-input">
                <b-form-input
                  id="max-transaction-input"
                  v-model="nominal.max_transaction"
                  @keypress="onlyNumber"
                  @input="formatRupiah($event, 'max_transaction')"
                ></b-form-input>
              </b-form-group>
            </form>
            <template #modal-footer="{ cancel }">
              <b-button size="sm" variant="danger" @click="cancel()"> Batal </b-button>
              <b-button size="sm" variant="primary" @click.prevent="handleSubmitLimitRek">
                Simpan
              </b-button>
            </template>
          </b-modal>
          <b-dropdown v-if="showbtnoption" class="float-right" right size="sm" text="Options">
            <b-dropdown-item
              v-if="showcheckduplicate"
              size="sm"
              target="_blank"
              variant="warning"
              @click.prevent="checkDuplicate()"
              ><i class="fa fa-trash-restore"></i> Check Duplicate
            </b-dropdown-item>
            <b-dropdown-item
              v-if="viewqr"
              size="sm"
              target="_blank"
              variant="primary"
              @click.prevent="printQr('all', 'Semua QR Santri')"
              ><i class="fa fa-id-card"></i> Lihat QR
            </b-dropdown-item>
            <b-dropdown-item v-if="showcreatebutton" :to="urlcreate" size="sm" variant="primary"
              ><i class="fas fa-plus"></i> Tambah Data
            </b-dropdown-item>
            <b-dropdown-item
              v-if="showgeneratecode"
              size="sm"
              variant="info"
              @click="generateCode()"
              ><i class="fas fa-file-download"></i> Kode Aktivasi
            </b-dropdown-item>
            <b-dropdown-item
              v-if="showwageneratecode"
              size="sm"
              variant="info"
              @click="SendWaActivation()"
              ><i class="fa fa-mobile"></i> Kode Aktivasi WA
            </b-dropdown-item>
            <b-dropdown-item v-if="isexported" size="sm" variant="success" @click="exportExcel()"
              ><i class="fas fa-file-excel"></i> Export
            </b-dropdown-item>
            <b-dropdown-item v-if="isimported" :to="urlimport" size="sm" variant="success"
              ><i class="fas fa-file-import"></i> Import
            </b-dropdown-item>
            <b-dropdown-item v-if="showprint" size="sm" variant="outline-info" @click="printData()"
              ><i class="fas fa-print"></i> Print
            </b-dropdown-item>
            <b-dropdown-item v-if="isuploaded" :to="urlupload" size="sm" variant="info"
              ><i class="fas fa-file-upload"></i> Upload
            </b-dropdown-item>
            <b-dropdown-item v-if="showrekeningbutton" :to="urlrekening" size="sm" variant="success"
              ><i class="fas fa-cube"></i> Lihat Rekening
            </b-dropdown-item>
            <b-dropdown-item
              v-if="showbtntagihanspp"
              :to="urlunpaid"
              class="mr-1"
              size="sm"
              title="Tagihan SPP Belum Lunas"
              variant="info"
              ><i class="fa fa-money-bill-wave"></i> SPP Belum Lunas
            </b-dropdown-item>
            <b-dropdown-item
              v-if="showgeneraterekeningbutton"
              size="sm"
              variant="primary"
              @click="generateRekening()"
              ><i class="fas fa-check-circle"></i> Generate Rekening
            </b-dropdown-item>
          </b-dropdown>
          <div id="printerDiv" style="display: none"></div>
          <b-button
            v-if="showfilterbutton"
            v-b-toggle="variablefilter"
            class="float-right mr-1"
            size="sm"
            variant="primary"
            ><i class="fa fa-filter"></i> Filter Data
          </b-button>
          <b-col v-if="isfiltered" class="float-right mr-1" cols="3">
            <b-input-group>
              <b-form-input
                v-model="search"
                placeholder="Cari data..."
                size="sm"
                @keypress.enter="searchData"
              ></b-form-input>
              <b-input-group-append>
                <b-button size="sm" text="Button" variant="primary" @click="searchData">
                  <i class="fas fa-search"></i> Cari
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-col>
        </template>
        <template #default>
            <b-table
              id="my-table"
              ref="PrintData"
              :bordered="true"
              :busy="isBusy"
              :fields="fields"
              :hover="true"
              :items="items"
              :striped="true"
              responsive
              show-empty
              small
              style="min-height: 200px"
            >
              <template #table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle" type="grow" label="Loading..."></b-spinner>
                  <strong class="ml-2">Memuat data...</strong>
                </div>
              </template>
              <template v-if="topheader" #thead-top="">
                <b-tr>
                  <b-th
                    v-for="(v, i) in dataTopHeader"
                    :key="i"
                    :colspan="v.colspan"
                    :variant="v.variant"
                    style="text-align: center"
                    ><span class="sr-only"></span>{{ v.name }}
                  </b-th>
                </b-tr>
              </template>
              <template #head(checkbox)="data">
                <b-form-checkbox
                  v-model="isCheckedAll"
                  :value="data.label"
                  class="ml-2"
                  @change="changeCheckedAll"
                ></b-form-checkbox>
              </template>

              <template #cell(customer_name_link)="row">
                <b-link @click="showsppcard(row.item.customer_id)"
                  >{{ row.item.customer_name_link }}
                </b-link>
              </template>
              <template #empty="">
                <div class="text-center">
                  <h1 class="badge badge-info"><i class="fa fa-file"></i> Data Kosong</h1>
                </div>
              </template>
              <template #cell(is_autodebit)="item">
                <div class="text-center">
                  <span v-if="item.item.is_autodebit" class="badge badge-success">Yes</span>
                  <span v-else class="badge badge-danger">No</span>
                </div>
              </template>
              <template #cell(is_need_jurusan)="item">
                <div class="text-center">
                  <span v-if="item.item.is_need_jurusan" class="badge badge-success">Ya</span>
                  <span v-else class="badge badge-secondary">Tidak</span>
                </div>
              </template>
              <template #cell(description)="item">
                <div v-html="item.item.description">
                </div>
              </template>
              <template #cell(is_vendor)="item">
                <div class="text-center">
                  <span v-if="item.item.is_vendor" class="badge badge-success">Yes</span>
                  <span v-else class="badge badge-danger">No</span>
                </div>
              </template>
              <template #cell(products)="item">
                <div v-if="item?.item?.products">
                  <span
                    v-for="(p, x) in item?.item?.products.split('|')"
                    :key="x"
                    class="badge badge-success mr-1"
                    >{{ p }}</span
                  >
                </div>
                <div v-else class="text-center">-</div>
              </template>
              <template #cell(jurusans)="item">
                <div v-if="item?.item?.jurusans && item.item.jurusans.length">
                  <span
                    v-for="(j, x) in item.item.jurusans"
                    :key="x"
                    class="badge badge-info mr-1"
                    >{{ j }}</span
                  >
                </div>
                <div v-else class="text-center">-</div>
              </template>
              <template #cell(full_name)="item">
                <div v-if="item?.item?.full_name && item?.item?.full_name != ''">
                  {{ decodeHtml(item?.item?.full_name) }}
                </div>
                <div v-else class="text-center">
                  {{ decodeHtml(item?.item?.first_name) + ' ' + decodeHtml(item?.item?.last_name) }}
                </div>
              </template>
              <template #cell(code)="item">
                <div v-if="showfullcode">
                  {{ item.item.code }}
                </div>
                <div v-else-if="showqr">
                  <b-button
                    size="sm"
                    @click.prevent="
                      printQrLembaga(item.item.id, decodeHtml(item.item.name), 'pendaftaran')
                    "
                    >QR Code
                  </b-button>
                </div>
                <div v-else class="text-center">
                  {{ ('0' + item.item.code).slice(-2) }}
                </div>
              </template>
              <template #cell(bulan_awal)="item">
                <div v-if="item.item.bulan_awal && item.item.tahun_awal">
                  {{ setAjaran(item.item.tahun_awal, item.item.bulan_awal) }}
                </div>
                <div v-else class="text-center">-</div>
              </template>
              <template #cell(bulan_akhir)="item">
                <div v-if="item.item.bulan_akhir && item.item.tahun_akhir">
                  {{ setAjaran(item.item.tahun_akhir, item.item.bulan_akhir) }}
                </div>
                <div v-else class="text-center">-</div>
              </template>
              <template #cell(balance)="item">
                <div class="float-right">
                  {{ item.item.balance.toLocaleString('id-ID') }}
                </div>
              </template>
              <template #cell(pendaftaran_balance)="item">
                <div class="float-right">
                  {{ (item.item.pendaftaran_balance || 0).toLocaleString('id-ID') }}
                </div>
              </template>
              <template #cell(total_balance)="item">
                <div class="float-right">
                  {{ item.item.total_balance.toLocaleString('id-ID') }}
                </div>
              </template>
              <template #cell(admin)="item">
                <div class="float-right">
                  {{ item.item.admin.toLocaleString('id-ID') }}
                </div>
              </template>
              <template #cell(min_saldo)="item">
                <div class="float-right">
                  {{ item.item.min_saldo.toLocaleString('id-ID') }}
                </div>
              </template>
              <template #cell(admin_bank)="item">
                <div class="float-right">
                  {{ item.item.admin_bank.toLocaleString('id-ID') }}
                </div>
              </template>
              <template #cell(admin_nash)="item">
                <div class="float-right">
                  {{ item.item.admin_nash.toLocaleString('id-ID') }}
                </div>
              </template>
              <template #cell(admin_institution)="item">
                <div class="float-right">
                  {{ item.item.admin_institution.toLocaleString('id-ID') }}
                </div>
              </template>
              <template #cell(max_transaction)="item">
                <div class="float-right">
                  {{ item.item.max_transaction.toLocaleString('id-ID') }}
                </div>
              </template>
              <template #cell(amount)="item">
                <div class="float-right">
                  {{ item.item.amount.toLocaleString('id-ID') }}
                </div>
              </template>
              <template #cell(gross_amount)="item">
                <div class="float-right">
                  {{ item.item.gross_amount.toLocaleString('id', 'ID') }}
                </div>
              </template>
              <template #cell(fee)="item">
                <div class="float-right">
                  {{ item.item.fee.toLocaleString('id', 'ID') }}
                </div>
              </template>
              <template #cell(price)="item">
                <div class="float-right">
                  {{ item.item.price.toLocaleString('id', 'ID') }}
                </div>
              </template>
              <template #cell(amount_kredit)="item">
                <div class="float-right">
                  {{ item.item.amount_kredit.toLocaleString('id-ID') }}
                </div>
              </template>
              <template #cell(min_nominal_teller)="item">
                <div class="float-right">
                  {{ item.item.min_nominal_teller.toLocaleString('id-ID') }}
                </div>
              </template>
              <template #cell(max_nominal_teller)="item">
                <div class="float-right">
                  {{ item.item.max_nominal_teller.toLocaleString('id-ID') }}
                </div>
              </template>
              <template #cell(mutasi)="item">
                <div class="float-right">
                  <span v-if="item.item.amount > 0" class="text-danger">
                    {{ '-' + item.item.amount.toLocaleString('id-ID') }}
                  </span>
                  <span v-else-if="item.item.amount_kredit > 0" class="text-success">
                    {{ item.item.amount_kredit.toLocaleString('id-ID') }}
                  </span>
                </div>
              </template>
              <template #cell(is_active)="item">
                <div class="text-center">
                  <span v-if="item.item.is_active" class="badge badge-success">Active</span>
                  <span v-else class="badge badge-danger">Non Active</span>
                </div>
              </template>
              <template #cell(status)="item">
                <div class="text-center">
                  <span v-if="item.item.status" class="badge badge-success">Active</span>
                  <span v-else class="badge badge-danger">Non Active</span>
                </div>
              </template>
              <template #cell(is_transfered)="item">
                <div class="text-center">
                  <span v-if="item.item.is_transfered == 'success'" class="badge badge-success"
                    >Success</span
                  >
                  <span v-else-if="item.item.is_transfered == 'process'" class="badge badge-info"
                    >Process</span
                  >
                  <span v-else class="badge badge-warning">Pending</span>
                </div>
              </template>
              <template #cell(is_implemented)="item">
                <div class="text-center">
                  <span v-if="item.item.is_implemented" class="badge badge-success"
                    >Implemented</span
                  >
                  <span v-else class="badge badge-danger">Waiting List</span>
                </div>
              </template>
              <template #cell(is_staff)="item">
                <div class="text-center">
                  <span v-if="item.item.is_staff" class="badge badge-success">Yes</span>
                  <span v-else class="badge badge-danger">No</span>
                </div>
              </template>
              <template #cell(transaction_status)="item">
                <div class="text-center">
                  <span
                    v-if="item.item.transaction_status === 'pending'"
                    class="badge badge-warning"
                    >Pending</span
                  >
                  <span
                    v-else-if="item.item.transaction_status === 'settlement'"
                    class="badge badge-success"
                    >Settlement</span
                  >
                  <span
                    v-else-if="item.item.transaction_status === 'expired'"
                    class="badge badge-secondary"
                    >Expired</span
                  >
                  <span
                    v-else-if="item.item.transaction_status === 'rejected'"
                    class="badge badge-danger"
                    >Rejected</span
                  >
                  <span
                    v-else-if="item.item.transaction_status === 'canceled'"
                    class="badge badge-info"
                    >Canceled</span
                  >
                </div>
              </template>
              <template #cell(name)="item">
                <div v-if="item.item.level">
                  <i v-for="(v, i) in item.item.level" :key="i">
                    {{ '&emsp;' }}
                  </i>
                  {{ decodeHtml(item.item.name) }}
                </div>
                <div v-else>
                  {{ decodeHtml(item.item.name) }}
                </div>
              </template>
              <template #cell(checkbox)="item">
                <div class="text-center">
                  <b-form-checkbox
                    v-if="item.item.is_transfered !== 'success'"
                    v-model="checkbox"
                    :value="item.item.id"
                    class="ml-2"
                  ></b-form-checkbox>
                </div>
              </template>
              <template #cell(level)="item">
                <div class="text-center">
                  {{ item.item.level }}
                </div>
              </template>
              <template #cell(saldo)="item">
                <div class="float-right">
                  {{ item.item.saldo.toLocaleString('id', 'ID') }}
                </div>
              </template>
              <template #cell(saldo_awal)="item">
                <div class="float-right">
                  {{ item.item.saldo_awal.toLocaleString('id', 'ID') }}
                </div>
              </template>
              <template #cell(saldo_akhir)="item">
                <div class="float-right">
                  {{ item.item.saldo_akhir.toLocaleString('id', 'ID') }}
                </div>
              </template>
              <template #cell(is_pusat)="item">
                <div class="text-center">
                  <span v-if="item.item.is_pusat" class="badge badge-info">Yes</span>
                  <span v-else class="badge badge-warning">No</span>
                </div>
              </template>
              <template #cell(paid)="item">
                <div class="text-center">
                  <span v-if="item.item.paid === 'Y'" class="badge badge-success">Lunas</span>
                  <span v-else class="badge badge-warning">Belum Lunas</span>
                </div>
              </template>
              <template #cell(birth_date)="item">
                {{ formatBirthDate(item.item.birth_date) }}
              </template>
              <template #cell(created_at)="item">
                {{ formatBirthDateTime(item.item.created_at) }}
              </template>
              <template #cell(transaction_date)="item">
                {{ formatBirthDateTime(item.item.transaction_date) }}
              </template>
              <template #cell(icon)="item">
                <div v-if="item.item.icon && item.item.icon !== '-'" class="text-center">
                  <img :src="item.item.icon" alt="icon" width="30" />
                </div>
                <div v-else class="text-center">-</div>
              </template>
              <template #cell(file_nilai)="item">
                <div
                  v-if="item.item.file_nilai"
                  class="text-center"
                >
                  <i
                    :title="item.item.file_nilai.split('/').pop()"
                    class="fa pointer fs-1-75"
                    :class="
                      getExtention(item.item.file_nilai) === 'pdf'
                        ? 'fa-file-pdf text-info'
                        : 'fa-file-excel text-success'
                    "
                    @click="previewFile(item.item.file_nilai)"
                  ></i>
                </div>
                <div v-else class="text-center">-</div>
              </template>
              <template #cell(path_url)="item">
                <div v-if="item.item.path_url" class="text-center">
                  <i
                    :title="item.item.path_url.split('/').pop()"
                    class="fa pointer fs-1-75"
                    :class="
                      getExtention(item.item.path_url) === 'pdf'
                        ? 'fa-file-pdf text-info'
                        : 'fa-file-excel text-success'
                    "
                    @click="previewFile(item.item.path_url)"
                  ></i>
                </div>
                <div v-else class="text-center">-</div>
              </template>
              <template v-if="showaction" #cell(actions)="item">
                <div class="text-center">
                  <b-dropdown class="float-right" right size="sm" text="Aksi" variant="info">
                    <b-dropdown-item
                      v-if="showcreatewithidbutton"
                      :to="
                        urlcreate +
                        '?parent_id=' +
                        item?.item?.order_number +
                        '&institution_id=' +
                        item?.item?.institution_id
                      "
                      class="mr-1"
                      size="sm"
                      title="Tambah Data"
                      variant="outline-success"
                      ><i class="fa fa-plus"></i> Tambah Data
                    </b-dropdown-item>
                    <b-dropdown-item
                      v-if="showsubdata"
                      :title="subdatatext"
                      :to="urlsubdata + '?id=' + item.item.id"
                      class="mr-1"
                      size="sm"
                      variant="outline-success"
                      ><i class="fa fa-plus"></i>
                      {{ subdatatext }}
                    </b-dropdown-item>
                    <b-dropdown-item
                      v-if="scanqrwa"
                      :title="'Scan QR WA'"
                      :to="urlscanqrwa + '?id=' + item.item.id"
                      class="mr-1"
                      size="sm"
                      variant="outline-success"
                      ><i class="fa fa-qrcode"></i>
                      Scan QR WA
                    </b-dropdown-item>
                    <b-dropdown-item
                      v-if="
                        showactivebutton &&
                        !item.item.is_lock &&
                        !item.item.kode_booking &&
                        !item.item.is_pusat
                      "
                      :title="
                        activetextbutton
                          ? activetextbutton
                          : item.item.is_active
                          ? 'Non-aktifkan'
                          : 'Aktifkan'
                      "
                      :variant="item.item.is_active ? 'info' : 'success'"
                      class="mr-1"
                      size="sm"
                      @click="ChangeStatus(item.item.id, item.item.is_active)"
                      ><i :class="'fa fa-' + (item.item.is_active ? 'times' : 'check')"></i>
                      <span v-if="activetextbutton">{{ activetextbutton }}</span>
                      <span v-else>
                        {{ item.item.is_active ? 'Non-aktifkan' : 'Aktifkan' }}
                      </span></b-dropdown-item
                    >
                    <b-dropdown-item
                      v-if="showstatusbutton && !item.item.is_pusat"
                      :title="
                        activetextbutton
                          ? activetextbutton
                          : item.item.status
                          ? 'Non-Aktifkan'
                          : 'Aktifkan'
                      "
                      :variant="item.item.status ? 'info' : 'success'"
                      class="mr-1"
                      size="sm"
                      @click="ChangeStatusPPOB(item.item.id, item.item.status)"
                      ><i :class="'fa fa-' + (item.item.status ? 'times' : 'check')"></i>
                      <span v-if="activetextbutton">{{ activetextbutton }}</span>
                      <span v-else>
                        {{ item.item.status ? 'Non-Aktifkan' : 'Aktifkan' }}
                      </span></b-dropdown-item
                    >
                    <b-dropdown-item
                      v-if="showactivesettdatafix"
                      :title="item.item.status === 1 ? 'Non-aktifkan' : 'Aktifkan'"
                      :variant="item.item.status === 1 ? 'info' : 'success'"
                      class="mr-1"
                      size="sm"
                      @click="ChangeStatusSettDataFix(item.item)"
                      ><i :class="'fa fa-' + (item.item.status === 1 ? 'times' : 'check')"></i>
                      <span>
                        {{ item.item.status === 1 ? 'Non-aktifkan' : 'Aktifkan' }}
                      </span></b-dropdown-item
                    >
                    <b-dropdown-item
                      v-if="showactivebutton && item.item.kode_booking && !item.item.is_implemented"
                      :title="
                        activetextbutton
                          ? activetextbutton
                          : item.item.is_implemented
                          ? 'Terimplementasi'
                          : 'Implementasikan'
                      "
                      :variant="item.item.is_implemented ? 'info' : 'success'"
                      class="mr-1"
                      size="sm"
                      @click="ChangeStatusBooking(item.item.id, item.item.is_implemented)"
                      ><i :class="'fa fa-' + (item.item.is_implemented ? 'times' : 'check')"></i>
                      <span v-if="activetextbutton">{{ activetextbutton }}</span>
                      <span v-else>
                        {{ item.item.is_implemented ? 'Terimplementasi' : 'Implementasikan' }}
                      </span></b-dropdown-item
                    >
                    <b-dropdown-item
                      v-if="showcreatewithidbutton && showeditbutton && !item.item.is_lock"
                      :to="
                        '/' +
                        url +
                        '/' +
                        item.item.id +
                        '?parent_id=' +
                        item.item.parent_id +
                        '&institution_id=' +
                        item?.item?.institution_id
                      "
                      class="mr-1"
                      size="sm"
                      title="Edit"
                      variant="warning"
                      ><i class="fa fa-edit"></i> Ubah
                    </b-dropdown-item>
                    <b-dropdown-item
                      v-if="!showcreatewithidbutton && showeditbutton && !item.item.is_lock"
                      class="mr-1"
                      size="sm"
                      title="Edit"
                      variant="warning"
                      @click.prevent="goToEdit(item.item)"
                      ><i class="fa fa-edit"></i> Ubah
                    </b-dropdown-item>
                    <b-dropdown-item
                      v-if="showdeletebutton && !item.item.is_lock && !item.item.is_pusat"
                      class="mr-1"
                      size="sm"
                      title="Delete"
                      variant="danger"
                      @click.prevent="deleteData(item.item)"
                      ><i class="fa fa-trash"></i> Hapus
                    </b-dropdown-item>
                    <b-dropdown-item
                      v-if="viewqr"
                      class="mr-1"
                      size="sm"
                      title="Lihat QR"
                      variant="primary"
                      @click.prevent="printQr(item.item.id, decodeHtml(item.item.full_name))"
                      ><i class="fa fa-id-card"></i> Lihat QR
                    </b-dropdown-item>
                    <b-dropdown-item
                      v-if="customNominal && item.item.is_autodebit"
                      :to="`/${url}/custom-nominal/${item.item.id}`"
                      class="mr-1"
                      size="sm"
                      title="Custom Nominal"
                      variant="success"
                      ><i class="fa fa-money-bill-wave"></i> Custom Nominal
                    </b-dropdown-item>
                    <b-dropdown-item
                      v-if="showuservendorbutton"
                      :to="`${urluservendor}/${item.item.id}`"
                      size="sm"
                      variant="success"
                      ><i class="fas fa-users"></i> List User Vendor
                    </b-dropdown-item>
                    <b-dropdown-item
                      v-if="showrekeningbuttondetail"
                      :to="`${urlrekening}/${item.item.id}`"
                      size="sm"
                      variant="success"
                      ><i class="fas fa-cube"></i> Lihat Rekening
                    </b-dropdown-item>
                    <b-dropdown-item
                      v-if="showsantributton"
                      size="sm"
                      variant="info"
                      @click.prevent="showModalSantri(item.item)"
                      ><i class="fas fa-users"></i> Lihat Santri
                    </b-dropdown-item>
                    <b-dropdown-item
                      v-if="updatelimitrekening"
                      size="sm"
                      variant="warning"
                      @click.prevent="showModalLimitRek(item.item)"
                      ><i class="fas fa-money-bill-wave"></i> Ubah Limit Transaksi
                    </b-dropdown-item>
                    <b-dropdown-item
                      v-if="showdetailbutton"
                      :to="
                        urldetail !== '/'
                          ? `${urldetail}/${item.item.id}`
                          : `/${url}/${item.item.id}`
                      "
                      size="sm"
                      variant="info"
                      ><i class="fa fa-eye"></i> Show Details
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </template>

              <template #cell(show_details)="row">
                <b-button
                  :variant="row.detailsShowing ? 'warning' : 'info'"
                  class="mr-2"
                  size="sm"
                  @click="row.toggleDetails"
                >
                  {{ row.detailsShowing ? 'Hide' : 'Show' }} Details
                </b-button>
                <b-button
                  v-if="generateinvoice"
                  variant="warning"
                  class="mr-2"
                  size="sm"
                  @click.prevent="GenerateInvoice(row.item)"
                >
                  Generate Invoice
                </b-button>
                <b-button
                  v-if="payinvoice"
                  variant="warning"
                  class="mr-2"
                  size="sm"
                  @click.prevent="PayInvoice(row.item)"
                >
                  Bayar Invoice
                </b-button>
              </template>

              <template #row-details="item">
                <b-table
                  id="my-table"
                  :bordered="true"
                  :fields="fieldsdetail"
                  :hover="true"
                  :items="item.item.details"
                  responsive
                  show-empty
                  small
                >
                  <template #cell(price)="sub">
                    <div class="float-right">
                      {{ sub.item.price.toLocaleString('id', 'ID') }}
                    </div>
                  </template>
                  <template #cell(is_pokok)="sub">
                    <div class="text-center">
                      <span v-if="sub.item.is_pokok" class="badge badge-info">Ya</span>
                      <span v-else class="badge badge-warning">Bukan</span>
                    </div>
                  </template>
                  <template #cell(amount)="sub">
                    <div class="float-right">
                      {{ sub.item.amount.toLocaleString('id', 'ID') }}
                    </div>
                  </template>
                  <template #cell(amount_kredit)="sub">
                    <div class="float-right">
                      {{ sub.item.amount_kredit.toLocaleString('id', 'ID') }}
                    </div>
                  </template>
                </b-table>
              </template>

              <template #custom-foot="">
                <b-tr v-if="!isBusy && showjumlahbukubesar">
                  <b-th class="text-right" colspan="4">JUMLAH</b-th>
                  <b-th class="text-right"
                    >{{ saldo_awal > 0 ? saldo_awal.toLocaleString('id', 'ID') : 0 }}
                  </b-th>
                  <b-th class="text-right"
                    >{{ total_debit > 0 ? total_debit.toLocaleString('id', 'ID') : 0 }}
                  </b-th>
                  <b-th class="text-right"
                    >{{ total_kredit > 0 ? total_kredit.toLocaleString('id', 'ID') : 0 }}
                  </b-th>
                  <b-th class="text-right">{{ saldo_akhir.toLocaleString('id', 'ID') }} </b-th>
                </b-tr>
                <b-tr v-if="!isBusy && showjumlahneraca">
                  <b-th class="text-right" colspan="2">TOTAL {{ title.toUpperCase() }} </b-th>
                  <b-th class="text-right">{{ total_saldo_awal.toLocaleString('id', 'ID') }} </b-th>
                  <b-th class="text-right">{{ total_debit.toLocaleString('id', 'ID') }} </b-th>
                  <b-th class="text-right">{{ total_kredit.toLocaleString('id', 'ID') }} </b-th>
                  <b-th class="text-right"
                    >{{ total_saldo_akhir.toLocaleString('id', 'ID') }}
                  </b-th>
                </b-tr>
                <b-tr v-if="!isBusy && showsummary">
                  <b-th :colspan="fields?.length - 1" class="text-right">TOTAL </b-th>
                  <b-th class="text-right">{{ total_saldo_awal.toLocaleString('id', 'ID') }} </b-th>
                </b-tr>
                <b-tr v-if="!isBusy && showsummarynominatif">
                  <b-th :colspan="fields?.length - 1" class="text-right"
                    >Total dari {{ meta.count }} rekening
                  </b-th>
                  <b-th class="text-right">{{ totalnominatif.toLocaleString('id', 'ID') }} </b-th>
                </b-tr>
                <b-tr v-if="!isBusy && showsummaryspp">
                  <b-th :colspan="fields?.length - 2" class="text-right">TOTAL </b-th>
                  <b-th class="text-right"
                    >{{ summarySpp.total_paid.toLocaleString('id', 'ID') }}
                  </b-th>
                  <b-th class="text-right"
                    >{{ summarySpp.total_unpaid.toLocaleString('id', 'ID') }}
                  </b-th>
                </b-tr>
              </template>
              <template v-if="!isBusy" #table-caption>
                Total Rows : <b>{{ meta.count }}</b>
              </template>
            </b-table>
        </template>
        <template v-if="!isBusy && showpagination" #footer>
          <b-row align-h="end">
            <b-col class="my-0 text-right" md="2" sm="1">
              <b-form inline>
                <label class="mr-sm-2" for="per-page-select" size="sm"> Per Page </label>
                <b-form-select
                  id="per-page-select"
                  v-model="meta.limit"
                  :options="pageoptions"
                  class="mb-2 mr-sm-2 mb-sm-0"
                  size="sm w-35"
                  @change="getData"
                ></b-form-select>
              </b-form>
            </b-col>
            <b-pagination
              v-model="meta.page"
              :per-page="meta.limit"
              :total-rows="meta.count"
              class="mr-sm-2"
              first-text="First"
              last-text="Last"
              next-text="Next"
              prev-text="Prev"
              size="sm"
              @input="getData"
            ></b-pagination>
          </b-row>
        </template>
      </b-card>
    </b-card-group>
    <PreviewFile :show="modalFile.show" :url="modalFile.url" @close="resetModalFile" />
    <br />
  </div>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
import VueQRCodeComponent from 'vue-qrcode-component'

export default {
  name: 'MaterialCardTable',
  components: {
    VueQRCodeComponent,
    PreviewFile: () => import('@/components/modal/PreviewFile'),
  },
  inheritAttrs: false,
  props: {
    url: {
      type: String,
      default: '',
    },
    fetchOnMount: {
      type: Boolean,
      default: true,
    },
    showjumlahbukubesar: {
      type: Boolean,
      default: false,
    },
    showjumlahneraca: {
      type: Boolean,
      default: false,
    },
    activetextbutton: {
      type: String,
      default: null,
    },
    showcreatewithidbutton: {
      type: Boolean,
      default: false,
    },
    urlcreate: {
      type: String,
      default: '/',
    },
    viewqr: {
      type: Boolean,
      default: false,
    },
    viewqrurl: {
      type: String,
      default: '/',
    },
    urlexport: {
      type: String,
      default: '/',
    },
    urlgenerate: {
      type: String,
      default: '/',
    },
    urlwagenerate: {
      type: String,
      default: '/',
    },
    urlupload: {
      type: String,
      default: '/',
    },
    urlimport: {
      type: String,
      default: '/',
    },
    urlrekening: {
      type: String,
      default: '/',
    },
    urlbackbutton: {
      type: String,
      default: '/',
    },
    urlgeneraterekening: {
      type: String,
      default: '/',
    },
    urlsubdata: {
      type: String,
      default: '/',
    },
    color: {
      type: String,
      default: 'secondary',
    },
    title: {
      type: String,
      default: undefined,
    },
    customtitleleft: {
      type: String,
      default: undefined,
    },
    customtitleright: {
      type: String,
      default: undefined,
    },
    text: {
      type: String,
      default: undefined,
    },
    fields: {
      type: Array,
      default: null,
    },
    fieldsdetail: {
      type: Array,
      default: null,
    },
    subdatatext: {
      type: String,
      default: null,
    },
    showprint: {
      type: Boolean,
      default: false,
    },
    showsubdata: {
      type: Boolean,
      default: false,
    },
    scanqrwa: {
      type: Boolean,
      default: false,
    },
    urlscanqrwa: {
      type: String,
      default: '/',
    },
    showaction: {
      type: Boolean,
      default: false,
    },
    showcreatebutton: {
      type: Boolean,
      default: false,
    },
    showcheckduplicate: {
      type: Boolean,
      default: false,
    },
    showeditbutton: {
      type: Boolean,
      default: false,
    },
    showdeletebutton: {
      type: Boolean,
      default: false,
    },
    showrekeningbutton: {
      type: Boolean,
      default: false,
    },
    showrekeningbuttondetail: {
      type: Boolean,
      default: false,
    },
    showsantributton: {
      type: Boolean,
      default: false,
    },
    showgeneraterekeningbutton: {
      type: Boolean,
      default: false,
    },
    showfilterbutton: {
      type: Boolean,
      default: false,
    },
    showbackbutton: {
      type: Boolean,
      default: false,
    },
    showactivebutton: {
      type: Boolean,
      default: false,
    },
    showstatusbutton: {
      type: Boolean,
      default: false,
    },
    isfiltered: {
      type: Boolean,
      default: false,
    },
    isuploaded: {
      type: Boolean,
      default: false,
    },
    isexported: {
      type: Boolean,
      default: false,
    },
    isimported: {
      type: Boolean,
      default: false,
    },
    showgeneratecode: {
      type: Boolean,
      default: false,
    },
    showwageneratecode: {
      type: Boolean,
      default: false,
    },
    showpagination: {
      type: Boolean,
      default: true,
    },
    filters: {
      type: Boolean,
      default: false,
    },
    filterdatas: {
      type: Object,
      default: null,
    },
    variablefilter: {
      type: String,
      default: null,
    },
    exportfilename: {
      type: String,
      default: null,
    },
    exportmimetype: {
      type: String,
      default: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
    exportfileextension: {
      type: String,
      default: 'xlsx',
    },
    topheader: {
      type: Boolean,
      default: false,
    },
    dataTopHeader: {
      type: Array,
      default: null,
    },
    showsppcard: {
      type: Function,
      default: null,
    },
    customNominal: {
      type: Boolean,
      default: false,
    },
    showfullcode: {
      type: Boolean,
      default: false,
    },
    perpage: {
      type: Number,
      default: 10,
    },
    showbtnoption: {
      type: Boolean,
      default: true,
    },
    showsummary: {
      type: Boolean,
      default: false,
    },
    showsummarynominatif: {
      type: Boolean,
      default: false,
    },
    showsummaryspp: {
      type: Boolean,
      default: false,
    },
    urluservendor: {
      type: String,
      default: '/',
    },
    showuservendorbutton: {
      type: Boolean,
      default: false,
    },
    urlunpaid: {
      type: String,
      default: '/',
    },
    showbtntagihanspp: {
      type: Boolean,
      default: false,
    },
    urldelete: {
      type: String,
      default: '/',
    },
    showqr: {
      type: Boolean,
      default: false,
    },
    urlactivate: {
      type: String,
      default: '/',
    },
    showactivesettdatafix: {
      type: Boolean,
      default: false,
    },
    generateinvoice: {
      type: Boolean,
      default: false,
    },
    payinvoice: {
      type: Boolean,
      default: false,
    },
    updatelimitrekening: {
      type: Boolean,
      default: false,
    },
    showdetailbutton: {
      type: Boolean,
      default: false,
    },
    urldetail: {
      type: String,
      default: '/',
    },
  },
  data() {
    return {
      isBusy: false,
      search: '',
      items: [],
      total_debit: 0,
      total_kredit: 0,
      saldo_awal: 0,
      saldo_akhir: 0,
      totalnominatif: 0,
      total_saldo_awal: 0,
      total_saldo_akhir: 0,
      firstLoad: false,
      modalQR: {
        show: false,
        url: null,
        title: null,
        class: 'qr_iframe',
        limit: 10,
        page: 1,
        count: 0,
        paginate: false,
      },
      modalQRLembaga: {
        id: null,
        show: false,
        url: null,
        title: null,
        class: 'qr_iframe',
      },
      meta: {
        count: 0,
        limit: 10,
        next_page: 1,
        page: 1,
        previous_page: 1,
        total_pages: 1,
      },
      pageoptions: [5, 10, 20, 50],
      isCheckedAll: [],
      checkbox: [],
      modalLimitRek: {
        id: null,
        show: false,
        title: 'Ubah Limit Transaksi Rekening',
      },
      form: {
        max_transaction: '',
      },
      nominal: {
        max_transaction: '',
      },
      modalFile: {
        show: false,
        url: '',
      },
      summarySpp: {
        total_paid: 0,
        total_unpaid: 0,
      },
    }
  },
  computed: {
    ...mapState(['dataSummary', 'dataCheckbox']),
    hasOffset() {
      return this.$slots.header || this.$slots.offset || this.title || this.text
    },
    styles() {
      if (!this.hasOffset) return null
      return {
        marginBottom: `${this.offset}px`,
        marginTop: `${this.offset * 2}px`,
      }
    },
  },
  watch: {
    showSummary() {
      this.coltotal = this.showSummary
    },
    checkbox() {
      if (this.items.length > 0) {
        const count = this.items.filter((v) => v.is_transfered !== 'success').length
        this.isCheckedAll = count === this.checkbox.length ? ['all'] : []

        this.$store.commit(
          'SET_DATA_CHECKBOX',
          this.items
            .filter((f) => this.checkbox.includes(f.id))
            .map((f) => ({ id: f.id, amount: f.amount, details: f.details }))
        )
      }
    },
  },
  mounted() {
    if (this.fetchOnMount) {
      this.getData()
    }
  },
  methods: {
    decodeHtml(input) {
      const doc = new DOMParser().parseFromString(input, 'text/html')
      return doc.documentElement.textContent || ''
    },
    changeCheckedAll() {
      if (this.isCheckedAll.length > 0) {
        const checked = []
        this.items.forEach((x) => {
          if (x.is_transfered !== 'success') checked.push(x.id)
        })
        this.checkbox = [...new Set(checked)]
      } else {
        this.checkbox = []
      }
    },
    showModol() {
      alert('tes')
    },
    setAjaran(year, month) {
      if (!year || !month || year === 0 || month === 0) return '-'

      const formattedMonth = month.toString().padStart(2, '0')

      return moment(`${year}-${formattedMonth}-01`)
        .locale('id')
        .format('MMMM YYYY')
        .replace(/^\w/, (c) => c.toUpperCase())
    },
    printData() {
      const w = window.open()
      w.document.write(this.$refs.PrintData.$el.innerHTML)
      w.document.close()
      w.setTimeout(function () {
        w.print()
      }, 1000)
    },
    async generateCode() {
      await this.$axios
        .get('api/' + this.urlgenerate, {
          responseType: 'arraybuffer',
        })
        .then((res) => {
          const FILE = window.URL.createObjectURL(
            new Blob([res.data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            })
          )
          const docUrl = document.createElement('a')
          docUrl.href = FILE
          docUrl.setAttribute('download', 'kode_aktivasi.xlsx')
          document.body.appendChild(docUrl)
          docUrl.click()
        })
        .catch((res) => {
          this.$swal.fire({
            icon: 'warning',
            title: this.getApiErrorMessage(res),
            showConfirmButton: false,
            timer: 1500,
          })
        })
    },
    async SendWaActivation() {
      await this.$swal
        .fire({
          title: 'Apakah akan melakukan pengiriman kode aktivasi via Whatsapp ?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak',
        })
        .then((result) => {
          if (result.value) {
            this.$axios
              .post('api/' + this.urlwagenerate)
              .then((res) => {
                this.$swal
                  .fire({
                    icon: 'success',
                    title: 'Kode Aktivasi Berhasil dikirim ke Wali Santri.',
                    showConfirmButton: false,
                    timer: 1500,
                  })
                  .then((res) => {
                    this.getData()
                  })
              })
              .catch((res) => {
                this.$swal.fire({
                  icon: 'warning',
                  title: this.getApiErrorMessage(res),
                  showConfirmButton: false,
                  timer: 1500,
                })
              })
          }
        })
    },
    async generateRekening() {
      await this.$swal
        .fire({
          title: 'Apakah akan melakukan Generate Rekening ?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak',
        })
        .then((result) => {
          if (result.value) {
            this.$axios
              .post('api/' + this.urlgeneraterekening)
              .then((res) => {
                this.$swal
                  .fire({
                    icon: 'success',
                    title: 'Rekening berhasil digenerate.',
                    showConfirmButton: false,
                    timer: 1500,
                  })
                  .then((res) => {
                    this.getData()
                  })
              })
              .catch((res) => {
                this.$swal.fire({
                  icon: 'warning',
                  title: this.getApiErrorMessage(res),
                  showConfirmButton: false,
                  timer: 1500,
                })
              })
          }
        })
    },
    async exportExcel() {
      const q = []
      if (this.filterdatas && this.filterdatas !== null && this.filterdatas !== undefined) {
        Object.keys(this.filterdatas).forEach((f) => {
          if (this.filterdatas[f] && this.filterdatas[f] !== undefined) {
            q.push(`${f}=${encodeURIComponent(this.filterdatas[f])}`)
          }
        })
      }
      const qs = q.length ? `?${q.join('&')}` : ''
      const baseName = this.exportfilename || 'export'
      await this.$axios
        .get('api/' + this.urlexport + qs, {
          responseType: 'arraybuffer',
        })
        .then((res) => {
          const FILE = window.URL.createObjectURL(
            new Blob([res.data], {
              type: this.exportmimetype,
            })
          )
          const docUrl = document.createElement('a')
          docUrl.href = FILE
          docUrl.setAttribute('download', `${baseName}.${this.exportfileextension}`)
          document.body.appendChild(docUrl)
          docUrl.click()
        })
        .catch((res) => {
          this.$swal.fire({
            icon: 'warning',
            title: this.getApiErrorMessage(res),
            showConfirmButton: false,
            timer: 1500,
          })
        })
    },
    async ChangeStatus(id, isActive) {
      // gunakan variabel lokal agar tidak memodifikasi props
      const activeUrl = this.urlactivate !== '/' ? this.urlactivate : this.url

      await this.$swal
        .fire({
          title: (isActive ? 'non-aktifkan' : 'aktifkan') + ' data ini ?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak',
        })
        .then((result) => {
          if (result.value) {
            this.$axios
              .post('api/' + activeUrl + '/change-status/' + id, {
                is_active: isActive,
              })
              .then((res) => {
                this.$swal
                  .fire({
                    icon: 'success',
                    title: 'Data berhasil di ' + (isActive ? 'non-aktifkan' : 'aktifkan'),
                    showConfirmButton: false,
                    timer: 1500,
                  })
                  .then((res) => {
                    this.getData()
                  })
              })
              .catch((res) => {
                this.$swal.fire({
                  icon: 'warning',
                  title: this.getApiErrorMessage(res),
                  showConfirmButton: false,
                  timer: 1500,
                })
              })
          }
        })
    },
    async ChangeStatusSettDataFix(item) {
      const url =
        this.urlactivate.replace(':id', item.id) + `?institution_id=${item?.institution_id}`
      await this.$swal
        .fire({
          title: (item.status ? 'non-aktifkan' : 'aktifkan') + ' data ini ?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak',
        })
        .then((result) => {
          if (result.value) {
            this.$axios
              .post('api/' + url, { status: item.status })
              .then((res) => {
                this.$swal
                  .fire({
                    icon: 'success',
                    title: 'Data berhasil di ' + (item.status ? 'non-aktifkan' : 'aktifkan'),
                    showConfirmButton: false,
                    timer: 1500,
                  })
                  .then((res) => {
                    this.getData()
                  })
              })
              .catch((res) => {
                this.$swal.fire({
                  icon: 'warning',
                  title: this.getApiErrorMessage(res),
                  showConfirmButton: false,
                  timer: 1500,
                })
              })
          }
        })
    },
    async ChangeStatusPPOB(id, status) {
      // gunakan variabel lokal agar tidak memodifikasi props
      const activeUrl = this.urlactivate !== '/' ? this.urlactivate : this.url

      await this.$swal
        .fire({
          title: (status ? 'non-aktifkan' : 'aktifkan') + ' data ini ?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak',
        })
        .then((result) => {
          if (result.value) {
            this.$axios
              .put('api/' + activeUrl + '/change-status/' + id, { status })
              .then((res) => {
                this.$swal
                  .fire({
                    icon: 'success',
                    title: 'Data berhasil di ' + (status ? 'non-aktifkan' : 'aktifkan'),
                    showConfirmButton: false,
                    timer: 1500,
                  })
                  .then((res) => {
                    this.getData()
                  })
              })
              .catch((res) => {
                this.$swal.fire({
                  icon: 'warning',
                  title: this.getApiErrorMessage(res),
                  showConfirmButton: false,
                  timer: 1500,
                })
              })
          }
        })
    },
    async ChangeStatusBooking(id, isActive) {
      // gunakan variabel lokal agar tidak memodifikasi props
      const activeUrl = this.urlactivate !== '/' ? this.urlactivate : this.url

      await this.$swal
        .fire({
          title: (isActive ? 'non-aktifkan' : 'Implementasikan') + ' lembaga ini ?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak',
        })
        .then((result) => {
          if (result.value) {
            this.$axios
              .post('api/' + activeUrl + '/change-status/' + id, {
                is_active: isActive,
              })
              .then((res) => {
                this.$swal
                  .fire({
                    icon: 'success',
                    title: 'Data berhasil di ' + (isActive ? 'non-aktifkan' : 'implementasikan'),
                    showConfirmButton: false,
                    timer: 1500,
                  })
                  .then((res) => {
                    this.getData()
                  })
              })
              .catch((res) => {
                this.$swal.fire({
                  icon: 'warning',
                  title: this.getApiErrorMessage(res),
                  showConfirmButton: false,
                  timer: 1500,
                })
              })
          }
        })
    },
    searchData() {
      this.getData(this.search)
    },
    async getData() {
      const query = [`page=${this.meta.page}`, `limit=${this.meta.limit}`]

      if (this.search && this.search !== undefined) {
        this.meta.page = 1
        query.push(`q=${this.search}`)
      }

      if (this.filterdatas && this.filterdatas !== null && this.filterdatas !== undefined) {
        Object.keys(this.filterdatas).forEach((f) => {
          if (this.filterdatas[f] && this.filterdatas[f] !== undefined) {
            query.push(`${f}=${this.filterdatas[f]}`)
          }
        })
      }

      this.items = []
      this.isBusy = true
      await this.$axios
        .get(`api/${this.url}?${query.join('&')}`)
        .then((res) => {
          // Handle 2 different response formats
          // Format 1: res.data = { meta, data, summary, total }
          // Format 2: res.data.data = { data: [...], summary: {...} }
          let responseData = res.data
          let meta, data, summary, total

          // Check if format 2 (nested data.data)
          if (responseData?.data && typeof responseData.data === 'object' && Array.isArray(responseData.data.data)) {
            data = responseData.data.data
            summary = responseData.data.summary
            meta = responseData.data.meta
            total = responseData.data.total
          } else {
            // Format 1 (direct)
            meta = responseData.meta
            data = responseData.data
            summary = responseData.summary
            total = responseData.total
          }

          if (meta) {
            if (meta.count > 0 && !this.firstLoad) {
              this.firstLoad = true
            }

            this.meta.count = meta.count
          } else this.meta.count = data && data?.length

          if (Array.isArray(data) && data != null) {
            this.items = data
          } else if (!Array.isArray(data) && data != null) {
            this.items = [data]
          } else {
            this.items = []
          }

          if (this.items !== null) {
            if (this.showjumlahbukubesar) {
              // Check summary first (format 2), then fallback to direct (format 1)
              this.total_debit = summary?.total_debit ?? responseData?.total_debit
              this.total_kredit = summary?.total_kredit ?? responseData?.total_kredit
              this.saldo_awal = summary?.saldo_awal ?? responseData?.saldo_awal
              this.saldo_akhir = summary?.saldo_akhir ?? responseData?.saldo_akhir
            }
            if (this.showjumlahneraca) {
              this.total_debit = summary?.total_debit ?? responseData?.total_debit
              this.total_kredit = summary?.total_kredit ?? responseData?.total_kredit
              this.total_saldo_awal = summary?.total_saldo_awal ?? responseData?.total_saldo_awal
              this.total_saldo_akhir = summary?.total_saldo_akhir ?? responseData?.total_saldo_akhir
            }
            if (this.showsummarynominatif) {
              this.totalnominatif = total ?? responseData?.total
            }
            if (this.showsummary) {
              this.total_saldo_awal = total || 0
            }
          } else {
            this.items = []
          }
          if (summary) {
            this.$store.commit('SET_DATA_SUMMARY', summary)
          }
          this.isBusy = false
          this.isCheckedAll = []
          this.$store.commit('SET_DATA_CHECKBOX', [])
        })
        .catch((error) => {
          this.isBusy = false
          this.items = []
          this.$swal.fire({
            icon: 'error',
            title: 'Gagal memuat data',
            text: this.getApiErrorMessage(error, 'Terjadi kesalahan saat memuat data'),
            showConfirmButton: true,
          })
        })
    },
    fetchQRCode() {
      const url = window.location.origin + '/' + this.viewqrurl
      this.modalQR.url = url + `&page=${this.modalQR.page}&limit=${this.modalQR.limit}`
    },
    printQr(id, name) {
      this.modalQR.page = this.meta.page
      this.modalQR.limit = this.meta.limit
      this.modalQR.count = this.meta.count

      let url = window.location.origin + '/' + this.viewqrurl
      if (id !== 'all') {
        url += '&customer_id=' + id
        this.modalQR.class = 'qr_iframe'
        this.modalQR.paginate = false
      } else {
        this.modalQR.class = 'qr_iframe_all'
        url += `&page=${this.modalQR.page}&limit=${this.modalQR.limit}`
        this.modalQR.paginate = true
      }

      this.modalQR.url = url
      this.modalQR.title = name
      this.modalQR.show = true
    },
    printQrLembaga(id, name, type) {
      // const idEncode = btoa(id)
      const url = window.location.origin + '/auth/register-santri?code=' + id
      this.modalQRLembaga.text = type === 'code' ? id : url
      this.modalQRLembaga.id = id
      this.modalQRLembaga.url = url
      this.modalQRLembaga.title = name
      this.modalQRLembaga.show = true
    },
    async checkDuplicate() {
      await this.$swal
        .fire({
          title: 'cek duplikat data ?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak',
        })
        .then((result) => {
          if (result.value) {
            this.$axios.get('api/' + this.url + '/check/duplicate').then((res) => {
              this.$swal
                .fire({
                  icon: 'success',
                  title: 'Data duplikat berhasil dihapus',
                  showConfirmButton: false,
                  timer: 1500,
                })
                .then((res) => {
                  this.getData()
                })
            })
          }
        })
    },
    printDivQR() {
      document.querySelector('#printerDiv > iframe').contentWindow.print()
    },
    printDivQRLembaga() {
      const printContents = document.getElementById('printerDivLembaga').innerHTML
      const originalContents = document.body.innerHTML

      document.body.innerHTML = printContents

      window.print()

      document.body.innerHTML = originalContents
    },
    goToEdit(data) {
      let path = `/${this.url}/${data?.id}`
      if (this.urldelete && this.urldelete === 'setting-data-fix') {
        path += `?institution_id=${data?.institution_id}`
      }
      this.$router.push({ path })
    },
    async deleteData(data) {
      let urldelete = this.url + '/' + data?.id
      if (this.urldelete && this.urldelete !== '/') {
        if (this.urldelete === 'setting-data-fix') {
          urldelete = this.url + '/' + data?.id + `?institution_id=${data?.institution_id}`
        } else {
          urldelete = `${this.urldelete}/${data?.product_detail_id}/${data?.id}`
        }
      }

      await this.$swal
        .fire({
          title: 'hapus data ini ?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak',
        })
        .then((result) => {
          if (result.value) {
            this.$axios.delete('api/' + urldelete).then((res) => {
              this.$swal
                .fire({
                  icon: 'success',
                  title: 'Data berhasil di hapus',
                  showConfirmButton: false,
                  timer: 1500,
                })
                .then((res) => {
                  this.getData()
                })
            })
          }
        })
    },
    async GenerateInvoice(data) {
      this.checkbox = data?.id
      await this.$swal
        .fire({
          title: 'Apakah akan melakukan Generate Invoice ?',
          html: `Total Nominal: ${this.formatRupiah(data?.amount, 'summary')}`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak',
        })
        .then((result) => {
          if (result.value) {
            this.$axios
              .post('api/' + this.url, {
                transaction: [
                  {
                    institution_id: data?.id,
                    transaction_ids: data?.details?.map((d) => d?.id),
                  },
                ],
              })
              .then((res) => {
                this.$swal
                  .fire({
                    icon: 'success',
                    title: 'Invoice berhasil digenerate.',
                    showConfirmButton: false,
                    timer: 1500,
                  })
                  .then((res) => {
                    this.getData()
                  })
              })
              .catch((res) => {
                this.$swal.fire({
                  icon: 'warning',
                  title: this.getApiErrorMessage(res),
                  showConfirmButton: false,
                  timer: 1500,
                })
              })
          }
        })
    },
    async PayInvoice(data) {
      this.checkbox = data?.id
      await this.$swal
        .fire({
          title: 'Apakah akan selesaikan Invoice ini ?',
          html: data?.id,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak',
        })
        .then((result) => {
          if (result.value) {
            this.$axios
              .post('api/' + this.url, {
                invoice_code: data?.id,
                is_transfered: 'success',
              })
              .then((res) => {
                this.$swal
                  .fire({
                    icon: 'success',
                    title: 'Invoice berhasil diselesaikan.',
                    showConfirmButton: false,
                    timer: 1500,
                  })
                  .then((res) => {
                    this.getData()
                  })
              })
              .catch((res) => {
                this.$swal.fire({
                  icon: 'warning',
                  title: this.getApiErrorMessage(res),
                  showConfirmButton: false,
                  timer: 1500,
                })
              })
          }
        })
    },
    formatRupiah(value, type) {
      const numericValue = value.toString().replace(/[^\d]/g, '')
      const formatValue = new Intl.NumberFormat('id-ID').format(numericValue)

      if (type === 'summary') return formatValue

      this.nominal[type] = formatValue
      const newVal = this.nominal[type].toString().replace(/[^\d]/g, '')
      this.form[type] = newVal === '0' ? '' : newVal
    },
    showModalLimitRek(data) {
      this.formatRupiah(data?.max_transaction, 'max_transaction')
      this.modalLimitRek.id = data?.id
      this.modalLimitRek.title += ` ${data?.product_name} - ${this.decodeHtml(data?.full_name)}`
      this.modalLimitRek.show = true
    },
    showModalSantri(data) {
      this.$emit('show-santri', data)
    },
    async handleSubmitLimitRek() {
      await this.$axios
        .post(`api/santri/rekening/${this.modalLimitRek.id}/update-limit`, {
          max_transaction: parseInt(this.form?.max_transaction),
        })
        .then((res) => {
          this.$swal
            .fire({
              icon: 'success',
              title: 'Limit Transaksi Rekening berhasil diubah.',
              showConfirmButton: false,
              timer: 1500,
            })
            .then((res) => {
              this.modalLimitRek.id = null
              this.nominal.max_transaction = ''
              this.form.max_transaction = ''
              this.modalLimitRek.show = false
              this.getData()
            })
        })
        .catch((res) => {
          this.$swal.fire({
            icon: 'warning',
            title: this.getApiErrorMessage(res),
            showConfirmButton: false,
            timer: 1500,
          })
        })
    },
    previewFile(file) {
      this.modalFile.url = file
      this.modalFile.show = true
    },
    resetModalFile() {
      this.modalFile.url = ''
      this.modalFile.show = false
    },
  },
}
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
.fs-1-75 {
  font-size: 1.75rem;
}
.qr_iframe {
  width: 100%;
  min-height: 600px;
  border: none;
}
.qr_iframe_all {
  width: 100%;
  min-height: 800px;
  border: none;
}
</style>
